import BlogArticlePage from '../components/BlogArticles';
import { publicMeta } from './public-meta';

export const meta = publicMeta(
  'Directing AI Video with 3D | Cartwheel',
  'A controllable workflow that turns precise 3D blocking into directed, stylized AI video.',
);

export default BlogArticlePage;
